import { connect, ConnectedProps } from "react-redux";
import { PriceDropFOCreditBanner } from "./component";
import {
  isPriceDropFOCreditBannerEligibleSelector,
  currentPriceDropProtectionSelector,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => {
  return {
    isEligible: isPriceDropFOCreditBannerEligibleSelector(state),
    priceDropProtection: currentPriceDropProtectionSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PriceDropFOCreditBannerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPriceDropFOCreditBanner = connector(
  PriceDropFOCreditBanner
);
